module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cta":"Click on the social network to share"},"nl":{"cta":"Klik op het sociale network om te delen"}}')
  delete Component.options._Ctor
}
